import { render, staticRenderFns } from "./BaseFormItem.vue?vue&type=template&id=5052ab16&scoped=true"
import script from "./BaseFormItem.vue?vue&type=script&lang=js"
export * from "./BaseFormItem.vue?vue&type=script&lang=js"
import style0 from "./BaseFormItem.vue?vue&type=style&index=0&id=5052ab16&prod&lang=scss&scoped=true"
import style1 from "./BaseFormItem.vue?vue&type=style&index=1&id=5052ab16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5052ab16",
  null
  
)

export default component.exports